<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogShow" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>

        <v-card-text>{{ message }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="dialogShow = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialogShow: false,
      title: "",
      message: "",
    }
  },
}
</script>